import React, { useState } from 'react';
import { Dropdown, Modal, Input, Avatar, message, Form, Breadcrumb } from 'antd';
import { DownOutlined, EditOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Link, withRouter } from 'react-router-dom';
import { headerMenuConfig, asideMenuConfig, asideMenuConfig2, asideMenuConfig3, asideMenuConfig4 } from '@/menuConfig';
import styles from './index.module.scss';
import http from '../../../../server';

function findCrumbs(pathname) {
  const cfgs = [asideMenuConfig, asideMenuConfig2, asideMenuConfig3, asideMenuConfig4];
  for (const cfg of cfgs) {
    if (!Array.isArray(cfg)) continue;
    for (const top of cfg) {
      if (top.path === pathname) return [top.name];
      if (Array.isArray(top.children)) {
        const sub = top.children.find(c => c.path === pathname);
        if (sub) return [top.name, sub.name];
      }
    }
  }
  return [];
}

function Header(props) {
  const { location } = props;
  const crumbs = findCrumbs(location && location.pathname);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const onLogout = () => {
    localStorage.setItem('loginusername', '');
    localStorage.setItem('loginPassword', '');
    if (sessionStorage.getItem('userToken')) {
      http.post('/userLogin/v1/authApi/logout', {}, sessionStorage.getItem('userToken'));
      sessionStorage.setItem('userName', '');
      sessionStorage.setItem('userToken', '');
    }
  };

  const onChangePwd = async () => {
    try {
      const v = await form.validateFields();
      if (v.newPwd !== v.newPwd2) { message.error('两次输入的新密码不一致'); return; }
      const res = await http.post(
        `/userLogin/v1/authApi/changePwd?oldPassword=${encodeURIComponent(v.oldPwd)}&newPassword=${encodeURIComponent(v.newPwd)}`,
        '', sessionStorage.getItem('userToken'));
      if (!res.data.success) {
        message.error(res.data.errorMessage);
      } else {
        message.success('修改成功');
        form.resetFields();
        setVisible(false);
      }
    } catch (e) {}
  };

  const userName = sessionStorage.getItem('userName') || localStorage.getItem('userName') || '-';
  const isAdmin = sessionStorage.getItem('userRole') === '超级管理员';

  const userMenu = {
    items: [
      { key: 'pwd',    icon: <EditOutlined />, label: '修改密码', onClick: () => setVisible(true) },
      { key: 'logout', icon: <LogoutOutlined />, label: <Link to={isAdmin ? '/admin/login' : '/user/login'} onClick={onLogout}>退出</Link> },
    ],
  };

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <Breadcrumb items={[
          { title: '首页' },
          ...crumbs.map(c => ({ title: c })),
        ]} />
      </div>
      <div className={styles.right}>
        {headerMenuConfig && headerMenuConfig.length > 0 && headerMenuConfig.map((nav, idx) => (
          <a key={idx} href={`#${nav.path}`} className={styles.headerNavLink} style={{ marginRight: 12 }}>{nav.name}</a>
        ))}
        <Dropdown menu={userMenu} trigger={['click']} placement="bottomRight">
          <div className={styles.userPanel} style={{ cursor: 'pointer' }}>
            <Avatar size={32} src={sessionStorage.getItem('userAvatar')} icon={<UserOutlined />} className={styles.userAvatar} />
            <span className={styles.userName}>{userName}</span>
            <DownOutlined className={styles.iconDown} />
          </div>
        </Dropdown>

        <Modal title="修改密码" open={visible} onOk={onChangePwd} onCancel={() => setVisible(false)} okText="保存">
          <Form form={form} layout="vertical">
            <Form.Item name="oldPwd" label="旧密码" rules={[{ required: true, message: '请输入旧密码' }]}>
              <Input.Password placeholder="请输入旧密码" />
            </Form.Item>
            <Form.Item name="newPwd" label="新密码" rules={[{ required: true, message: '请输入新密码' }]}>
              <Input.Password placeholder="请输入新密码" />
            </Form.Item>
            <Form.Item name="newPwd2" label="确认新密码" rules={[{ required: true, message: '请再次输入新密码' }]}>
              <Input.Password placeholder="请再次输入新密码" />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </header>
  );
}

export default withRouter(Header);
